export const HOME_SIDEBAR_MAIN_KEYS = [
    "dashboard",
    "projects",
    "bd",
    "finances",
    "tasks",
    "timesheet",
    "knowledge-learning",
    "company-directory",
    "ai-tools",
    "surveys",
    "newsfeed",
    "notifications",
];
